import React, { useEffect, useState, useContext } from "react"
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
import { HomeOutlined, ContactsOutlined, EditOutlined, ExclamationCircleOutlined, ReadOutlined } from '@ant-design/icons';
import axios from "axios";
import { Avatar, Table, Switch, ConfigProvider, Modal, Button, Menu, Col, Row, message, Space, Checkbox, Carousel } from "antd";
import NewTable from "./components/NewTable";
import Label_language from '../language';
import AdminClassTimeModal from "./components/AdminClassTimeModal";
const label_language = Label_language.ems.children
const AdminClassTime = () => {
    const { confirm } = Modal;
    const [new_time_block, set_new_time_block] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, set_loading] = useState(0)
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [total, set_total] = useState(1);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [datas, setDatas] = useState([]);
    const [extra_columns, set_extra_columns] = useState(null);
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const [default_column, set_default_column] = useState([
        // {
        //     title: '課程開始日期',
        //     key: 'time_start',
        //     dataIndex: 'time_start',
        //     align: 'center',
        // },
        // {
        //     title: '課程結束日期',
        //     key: 'time_end',
        //     dataIndex: 'time_end',
        //     align: 'center',
        // },
        {
            title: '課程分類名稱',
            // name: 'lesson_category_name',
            sorter: false,
            align: 'center',
            key: 'lesson_category_name',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_lesson_category_name_${index}`}>{item.lesson_category_name}</p>
                ))
            ),
            fixed: 'left',
        },
        {
            title: '課程開始日期',
            // name: 'time_start',
            sorter: false,
            align: 'center',
            key: 'time_start',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_time_start_${index}`}>{item.time_start}</p>
                ))
            ),
            fixed: 'left',
        },
        {
            title: '課程結束日期',
            name: 'time_end',
            sorter: false,
            align: 'center',
            key: 'time_end',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_time_end_${index}`}>{item.time_end}</p>
                ))
            ),
            fixed: 'left',
        },
        {
            title: '請假時數限制',
            sorter: false,
            align: 'center',
            key: 'leave_limit',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_leave_limit_${index}`}>{item.leave_limit} 小時</p>
                ))
            ),
        },
        {
            title: '上午開始時間',
            sorter: false,
            align: 'center',
            key: 'morning_start',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_morning_start_${index}`}>{item.morning_start}</p>
                ))
            ),
        },
        {
            title: '上午結束時間',
            sorter: false,
            align: 'center',
            key: 'morning_end',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_morning_end_${index}`}>{item.morning_end}</p>
                ))
            ),
        },
        {
            title: '下午開始時間',
            sorter: false,
            align: 'center',
            key: 'afternoon_start',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_afternoon_start_${index}`}>{item.afternoon_start}</p>
                ))
            ),
        },
        {
            title: '下午結束時間',
            sorter: false,
            align: 'center',
            key: 'afternoon_end',
            render: (text, record) => (
                record.new_time_block?.map((item, index) => (
                    <p key={`${record.time_id}_afternoon_end_${index}`}>{item.afternoon_end}</p>
                ))
            ),
        },
        {
            title: label_language.Common.children.control[language],
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEditRow(record)}>{label_language.Common.children.edit[language]}</Button>
                    <Button type="text" style={{ color: 'red' }} onClick={() => showMessage(record.time_id)}>{label_language.Common.children.delete[language]}</Button>
                </>
            )
        },
    ]);
    const showMessage = (value) => {
        confirm({
            title: label_language.Common.children.sure_delete[language],
            icon: <ExclamationCircleOutlined />,
            okText: label_language.Common.children.sure[language],
            okType: 'primary',
            cancelText: label_language.Common.children.cancel[language],
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/class_time`, {
                data: [{ time_id: value }]
            })
            .then((response) => {
                if (response.data.status != undefined) {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.delete_error[language],
                        });
                        reload();

                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.delete_success[language],
                        });
                        reload();
                    }
                }
            })

    }
    const getData = (param, sort, filter, checklist) => {
        // console.log(param);
        set_loading(true);
        set_choose_column(checklist);
        set_custom_filter_value(param?.keyword);
        return axios
            .get('/cramSchool/api/class_time', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                },

            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'admission_time',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'admission_time'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        getData();
    }, []);
    const handleOnEditRow = (record) => {
        setTitle(label_language.Common.children.edit[language]);
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record)
    }
    const handleOnAddRow = () => {
        setTitle(label_language.Common.children.add[language]);
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({ item: { time_start: '', time_end: '' } }); // 确保初始化包含 item 对象及其属性
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const handleEdit = () => {
        if (editcard.item.time_end == undefined || editcard.item.time_end == '' || editcard.item.time_start == '' || editcard.item.time_start == undefined) {
            messageApi.open({
                type: 'error',
                content: '修改失敗，請填寫必填欄位',
            });
        } else {
            axios
                .patch(`/cramSchool/api/class_time`, [
                    {
                        ...editcard,
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.edit_error[language],
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.edit_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    const handleSubmit = () => {

        if (editcard.time_end == undefined || editcard.time_end == '' || editcard.time_start == '' || editcard.time_start == undefined) {
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫必填欄位',
            });
        } else {
            axios
                .post(`/cramSchool/api/class_time`, [
                    {
                        ...editcard,
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.add_error[language],
                        });
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.add_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'time_id': value })
            })
            axios
                .delete(`/cramSchool/api/class_time`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.delete_error[language],
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.delete_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    return (
        <>
            {contextHolder}
            <AdminClassTimeModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                new_time_block={new_time_block}
                set_new_time_block={set_new_time_block} // 传递 set_new_time_block
            />
            <Row justify={'space-between'} style={{ paddingTop: '10px' }}>
                <Col span={24} >
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'ClassTimeList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add_button_title={'新增課程時間'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'time_id'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        searchdate={false}
                    ></NewTable>
                </Col>
            </Row></>
    )
}
export default AdminClassTime;
